import {moduleActions} from '../redux/modules';

export const initDashboardServiceCalls = (dispatch) => {
  Promise.all([
    dispatch(moduleActions.getCustomerInfo()),
    dispatch(moduleActions.QCDHistory()),
    dispatch(moduleActions.getTRPFunds()),
    dispatch(moduleActions.getExistingBanks()),
    dispatch(moduleActions.getaAssociatedAgreements()),
    dispatch(moduleActions.getProductTypes()),
    dispatch(moduleActions.getUserManager()),
    dispatch(moduleActions.getPersonalInformation()),
    dispatch(moduleActions.applicationDataLoading()),
    dispatch(moduleActions.getUserFunds()),
    dispatch(moduleActions.getRMDLimits()),
    dispatch(moduleActions.getStateWithholdingData()),
    dispatch(moduleActions.getRecentTransactions()),
    dispatch(moduleActions.getExistingAutoExchange()),
    dispatch(moduleActions.getExistingAutoSell()),
    dispatch(moduleActions.clearShoppingCart()),
    dispatch(moduleActions.getPaperlessTermsAndConditions())
  ]).then(
    () => {
      dispatch(moduleActions.getUserMessages());
      dispatch(moduleActions.applicationDataLoaded());
    },
    (e) => {
      console.log(e);
      dispatch(moduleActions.applicationDataFailed());
    }
  );
};

const initServiceCalls = (dispatch) => {
  Promise.all([
    dispatch(moduleActions.getCustomerInfo()),
    dispatch(moduleActions.getTRPFunds()),
    dispatch(moduleActions.getExistingBanks()),
    dispatch(moduleActions.getaAssociatedAgreements()),
    dispatch(moduleActions.getProductTypes()),
    dispatch(moduleActions.getUserManager()),
    dispatch(moduleActions.getPersonalInformation()),
    dispatch(moduleActions.applicationDataLoading()),
    dispatch(moduleActions.getUserFunds()),
    dispatch(moduleActions.getRMDLimits()),
    dispatch(moduleActions.getStateWithholdingData()),
    dispatch(moduleActions.getRecentTransactions()),
    dispatch(moduleActions.getExistingAutoExchange()),
    dispatch(moduleActions.getExistingAutoSell()),
    dispatch(moduleActions.clearShoppingCart()),
    dispatch(moduleActions.getPaperlessTermsAndConditions())
  ]).then(
    () => {
      dispatch(moduleActions.getUserMessages());
      dispatch(moduleActions.applicationDataLoaded());
    },
    (e) => {
      console.log(e);
      dispatch(moduleActions.applicationDataFailed());
    }
  );
};

export default initServiceCalls;
